import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../wayfinder'
/**
* @see \App\Http\Controllers\RunController::store
* @see Http/Controllers/RunController.php:21
* @route '/runs'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/runs',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\RunController::store
* @see Http/Controllers/RunController.php:21
* @route '/runs'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\RunController::store
* @see Http/Controllers/RunController.php:21
* @route '/runs'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\RunController::store
* @see Http/Controllers/RunController.php:21
* @route '/runs'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\RunController::store
* @see Http/Controllers/RunController.php:21
* @route '/runs'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\RunController::show
* @see Http/Controllers/RunController.php:46
* @route '/runs/{run}'
*/
export const show = (args: { run: string | number | { id: string | number } } | [run: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/runs/{run}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\RunController::show
* @see Http/Controllers/RunController.php:46
* @route '/runs/{run}'
*/
show.url = (args: { run: string | number | { id: string | number } } | [run: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { run: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { run: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            run: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        run: typeof args.run === 'object'
        ? args.run.id
        : args.run,
    }

    return show.definition.url
            .replace('{run}', parsedArgs.run.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\RunController::show
* @see Http/Controllers/RunController.php:46
* @route '/runs/{run}'
*/
show.get = (args: { run: string | number | { id: string | number } } | [run: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\RunController::show
* @see Http/Controllers/RunController.php:46
* @route '/runs/{run}'
*/
show.head = (args: { run: string | number | { id: string | number } } | [run: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\RunController::show
* @see Http/Controllers/RunController.php:46
* @route '/runs/{run}'
*/
const showForm = (args: { run: string | number | { id: string | number } } | [run: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\RunController::show
* @see Http/Controllers/RunController.php:46
* @route '/runs/{run}'
*/
showForm.get = (args: { run: string | number | { id: string | number } } | [run: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\RunController::show
* @see Http/Controllers/RunController.php:46
* @route '/runs/{run}'
*/
showForm.head = (args: { run: string | number | { id: string | number } } | [run: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\RunController::cancel
* @see Http/Controllers/RunController.php:62
* @route '/runs/{run}/cancel'
*/
export const cancel = (args: { run: string | number | { id: string | number } } | [run: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: cancel.url(args, options),
    method: 'post',
})

cancel.definition = {
    methods: ["post"],
    url: '/runs/{run}/cancel',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\RunController::cancel
* @see Http/Controllers/RunController.php:62
* @route '/runs/{run}/cancel'
*/
cancel.url = (args: { run: string | number | { id: string | number } } | [run: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { run: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { run: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            run: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        run: typeof args.run === 'object'
        ? args.run.id
        : args.run,
    }

    return cancel.definition.url
            .replace('{run}', parsedArgs.run.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\RunController::cancel
* @see Http/Controllers/RunController.php:62
* @route '/runs/{run}/cancel'
*/
cancel.post = (args: { run: string | number | { id: string | number } } | [run: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: cancel.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\RunController::cancel
* @see Http/Controllers/RunController.php:62
* @route '/runs/{run}/cancel'
*/
const cancelForm = (args: { run: string | number | { id: string | number } } | [run: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: cancel.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\RunController::cancel
* @see Http/Controllers/RunController.php:62
* @route '/runs/{run}/cancel'
*/
cancelForm.post = (args: { run: string | number | { id: string | number } } | [run: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: cancel.url(args, options),
    method: 'post',
})

cancel.form = cancelForm

const runs = {
    store: Object.assign(store, store),
    show: Object.assign(show, show),
    cancel: Object.assign(cancel, cancel),
}

export default runs